import BankCardItem from './bank-card-item';

export default BankCardItem;
